import React from 'react'
import { resolvePrefix } from '@toasttab/shared/src/utils/assetUtils'
interface BrollVideoProps {
  videoName: string
  webm?: {
    av1?: string
    vp9?: string
  }
}

const BrollVideo = ({ videoName, webm = null }: BrollVideoProps) => {
  if (!videoName) {
    return null
  }

  const av1Source =
    webm?.av1 && webm.av1 !== '' ? (
      <source
        src={resolvePrefix(webm.av1)}
        type='video/webm; codecs=av01.0.05M.08'
      />
    ) : null

  const vp9Source =
    webm?.vp9 && webm.vp9 !== '' ? (
      <source src={resolvePrefix(webm.vp9)} type='video/webm; codecs=vp9' />
    ) : null

  return (
    <video
      aria-hidden='true'
      autoPlay
      className='h-full w-full object-cover z-10 lazyload'
      loop
      muted
      playsInline
      preload='auto'
    >
      {av1Source}
      {vp9Source}
      <source src={videoName} type='video/mp4' />
      Your browser does not support HTML5 video.
    </video>
  )
}

export default BrollVideo
